
import {compareDate,formattedDate} from "@/app/utils/DayJS"
import { generateUrl, redirectToLink, isUrlExisted } from "@/app/utils/Common"
import { getBanners } from "@/app/utils/request/requestList";
import { LangCode } from "@/app/utils/LanguageContext";

export const BannerOnclick = (banner: BannerData, bannerType?: "TopBanner" | "BottomBanner") => {
  if (banner.redirectionLink?.value) {
    const targetUrl = generateUrl(banner.redirectionLink?.value, { "b_cid": bannerType ? `SPLDSP_racing/simulcast_${bannerType}` : "" }, false, true)
    if (banner.target?.value == "01-NewPage") {
      redirectToLink(targetUrl, "_blank")
    }
    else {
      redirectToLink(targetUrl, "_parent")
    }
  }
}

const validateImageUrl = async (list: any) => {
  const results = await Promise.all(list.map(async (item:any) => await isUrlExisted(item.imageUrl.value)));  
  return list.filter((item:any, index:any) => results[index]);
};
  export const GetBanners=async (langCode: LangCode, bannerType: "Top" | "Bottom" | "Middle",callback:Function, isMobile:any = false)=>{
    await getBanners(langCode, bannerType)
      .then(async  (res: any) => {
        const now=formattedDate(new Date(),"YYYY-MM-DDTHH:mm:ss")
        let enableBannerList:BannerData[]=res?.banners?.bannerList.filter((item: BannerData)=>{
          const imageUrlValid = isMobile ? item.imageUrl_Mobile?.value || item.imageUrl?.value : item.imageUrl?.value;
          if(item.enabled?.value && imageUrlValid && item.onlineDatetime?.sourceDate){
             const onlinedate=compareDate(now, item.onlineDatetime.value,"after", true)
             const offlinedate=compareDate(now, item.OfflineDatetime.value,"before", true)
             if(onlinedate&&offlinedate){
                return true
             }
             else{
                return false
             }
          }
          else{
            return false
          }
        })  
        
        // if(enableBannerList.length) {
        //   enableBannerList = await validateImageUrl(enableBannerList)
        // }

        callback(enableBannerList)
      })
      .catch((e: any) => {
        console.log(e);
      });     
  }